module.exports = __webpack_public_path__ + "static/media/profilePic.324d055c.jpg";